import React from "react";

export default function GenerateDiv({ divClass, content }) {
  return <div className={divClass}>{content}</div>;
}
